import WYSIWYG, { Container } from './WYSIWYG'

export default WYSIWYG

export { Container }
